module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.4.0-237.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.4.0.md
// module id = 680
// module chunks = 294